import { Box } from '@mui/material'
import { CopyButton, LabeledText } from '../..'
import { getTxt } from '../helpers'
import { CellContentProps, TableType } from '../types'
import { isEditableTableCell } from '../utils'
import { InputContent } from './input-content'

export const CellContent = <RowDataType,>({
  cellProps,
  isMobile,
  row,
  ...rest
}: CellContentProps<RowDataType>) => {
  const { key } = cellProps
  let inputContentProps
  if (rest.type === TableType.Dynamic) {
    const inputTypeProps = cellProps.inputTypeProps
    if (isEditableTableCell(row, inputTypeProps)) {
      inputContentProps = {
        cellProps,
        isMobile,
        row,
        ...rest
      }
    }
  }
  if (inputContentProps) {
    return (
      <Box sx={{ mb: isMobile ? '15px' : undefined }}>
        <InputContent {...inputContentProps} />
      </Box>
    )
  } else if (cellProps.keyToCopy) {
    const rowTextToCopy = getTxt(row[cellProps.keyToCopy], cellProps)
    return <CopyButton content={rowTextToCopy} />
  } else {
    const cellTxt = getTxt(row[key], cellProps)
    return (
      <>
        {isMobile
          ? cellTxt && (
              <LabeledText
                label={cellProps.label}
                labelTranslationId={cellProps.labelTranslationId}
                texts={[cellTxt]}
              />
            )
          : cellTxt}
      </>
    )
  }
}
